import React, { useEffect } from 'react';
import { footerHtml, cdnUrls, aemStyles } from './static';
import { getPublicUrl } from '../../utils/publicPath';

const Footer = () => {
  useEffect(() => {
    // Create and inject AEM styles
    Object.entries(aemStyles).forEach(([key, css]) => {
      if (css) {
        const style = document.createElement('style');
        style.textContent = css;
        style.setAttribute('data-aem-footer', 'true');
        style.setAttribute('data-aem-style', key);
        document.head.appendChild(style);
      }
    });

    // Inject CDN resources
    cdnUrls.css.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.setAttribute('data-aem-footer', 'true');
      document.head.appendChild(link);
    });

    cdnUrls.js.forEach(url => {
      const script = document.createElement('script');
      script.src = url;
      script.setAttribute('data-aem-footer', 'true');
      document.head.appendChild(script);
    });

    // Cleanup function
    return () => {
      document.querySelectorAll('[data-aem-footer]').forEach(el => {
        el.remove();
      });
    };
  }, []);

  // Update image paths in the footer HTML
  const updatedFooterHtml = footerHtml
    .replace(/src="\/static\/images\//g, `src="${getPublicUrl('static/images/')}`);

  return (
    <div dangerouslySetInnerHTML={{ __html: updatedFooterHtml }} />
  );
};

export default Footer; 